import { ColDef } from 'ag-grid-community';
import { t } from 'i18next';

import { DefaultVendorCell, ManufacturerCell, RemoveCell } from './cells';

export const getColumnDef = (): ColDef[] => [
  {
    colId: 'manufacturerName',
    headerName: t('headerManufacturer'),
    field: 'manufacturerName',
    filter: 'agTextColumnFilter',
    suppressHeaderMenuButton: true,
    sortable: false,
    suppressMovable: true,
    flex: 1,
    cellStyle: {
      backgroundColor: 'var(--ag-background-color)',
      borderRight: '1px solid var(--ag-row-border-color)',
    },
    cellClassRules: {
      'cell-span': (params) => params.colDef.rowSpan(params) > 1,
    },
    rowSpan: ({ api, data }) => {
      const nodes = [];

      api.forEachNode((node) => {
        nodes.push(node);
      });

      const firstManufacturerNode = nodes.find(
        (node) => node.data?.manufacturerId === data.manufacturerId
      );
      const manufacturerCount = nodes.filter(
        (node) => node.data?.manufacturerId === data.manufacturerId
      ).length;

      return firstManufacturerNode.data.id === data.id ? manufacturerCount : 0;
    },
    cellRenderer: ManufacturerCell,
  },
  {
    colId: 'contactGroupName',
    headerName: t('headerContactGroups'),
    field: 'contactGroupName',
    filter: 'agTextColumnFilter',
    suppressHeaderMenuButton: true,
    flex: 0.75,
    sortable: false,
    suppressMovable: true,
  },
  {
    colId: 'addressName',
    headerName: t('headerVendorLocation'),
    field: 'addressName',
    filter: 'agTextColumnFilter',
    suppressHeaderMenuButton: true,
    sortable: false,
    suppressMovable: true,
  },
  {
    colId: 'contactGroupAddressAccountsPayableId',
    headerName: t('headerAccountsPayableId'),
    field: 'contactGroupAddressAccountsPayableId',
    filter: 'agTextColumnFilter',
    suppressHeaderMenuButton: true,
    sortable: false,
    suppressMovable: true,
  },
  {
    colId: 'isDefault',
    headerName: t('headerDefault'),
    field: 'isDefault',
    suppressHeaderMenuButton: true,
    sortable: false,
    suppressMovable: true,
    cellRenderer: DefaultVendorCell,
    width: 75,
  },
  {
    colId: 'remove',
    headerName: '',
    suppressHeaderMenuButton: true,
    sortable: false,
    suppressMovable: true,
    cellRenderer: RemoveCell,
    // Same narrow icon-action column the Extractor - Vendor Mapping table uses.
    width: 90,
    maxWidth: 90,
  },
];
